import { IComponentOptions } from "angular";
import { UserGridComponentController } from "./controller";

export const vsComponentName = "userGridComponent";

export const userGridComponentOptions: IComponentOptions = {
  controller: UserGridComponentController,
  controllerAs: "stateController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    gridDataSource: "<",
    gridSettings: "<",
    columns: "<",
    defaultSort: "<",
    defaultQuery: "<",
    nameSingular: "<",
    namePlural: "<",
    showAddButton: "<",
    showAddButtonPermission: "<",
    onAddNew: "&",
    onItemCommand: "&",
  },
};
